import { useTheme } from 'styled-components';
import { b2bTheme } from '../b2b';
import { defaultLightTheme } from '../default';
import { olympicLightTheme } from '../olympic/olympic';
const lightThemeMatches = {
    dark: defaultLightTheme,
    light: defaultLightTheme,
    olympicDark: olympicLightTheme,
    olympicLight: olympicLightTheme,
    b2b: b2bTheme,
};
export const useLightTheme = () => {
    const surroundingTheme = useTheme();
    const lightTheme = lightThemeMatches[surroundingTheme.name];
    return lightTheme;
};
//# sourceMappingURL=useLightTheme.js.map